import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './containers/App/App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './pwa/serviceWorkerRegistration';
import { createMockServer } from './dev/createMockApi';
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop';
import { createConsoleBanner } from './utils/createConsoleBanner';
import './styles/global.css';

createConsoleBanner();

if (process.env.REACT_APP_LOCAL_DEV === 'true') {
  createMockServer();
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Router>,
);

reportWebVitals();
serviceWorkerRegistration.register();
